export default theme => ({
  wrapper: {
    position: 'relative',
    overflow: 'hidden',
    margin: 15,
    // height: '30%'
  },
  container: {
    textShadow: '1px 1px 1px #000',
    position: 'absolute',
    bottom: theme.spacing.unit,
    right: 5, left: 5,
    color: '#fff !important',
    padding: '10px 10px 0 10px'
  },
  thumbnail: {
    width: '100%',
    maxWidth: '100%',
    height: '100%',
    // minHeight: 140,
    // maxHeight: 270,
    // margin: 2,
    background: 'url(/caffecinema/img/placeholder.png) no-repeat center center',
  },
  thumbnailWrapper: {
    // position: 'absolute'
  },
  title: {
    // position: 'absolute',
    // bottom: 10, left: 0, right: 0,
    marginBottom: 8,
    textShadow: '1px 1px 1px #000',
    fontWeight: 600,
    fontSize: 12,
    '& a': {
      color: '#fff',
      '&:hover': {
        color: '#aaa'
      }
    }
  },
  overTitle: {
    color: '#fff',
    textShadow: '1px 1px 1px #000',
    lineHeight: 1.7,
    fontWeight: 'normal',
    fontSize: 12,
  },
  authorName: {
    fontSize: 10,
  },
  footer: {
    // marginBottom: 5
    // position: 'absolute',
    // bottom: 7
  }
})

